import { api } from "./api";

export async function previewNoteShare(noteId, clientQuery = "") {
  const { data } = await api.get(`/portal/notes/${noteId}/share/preview${clientQuery}`);
  return data.preview;
}

export async function shareNoteWithClient(noteId, clientQuery = "") {
  const { data } = await api.post(`/portal/notes/${noteId}/share${clientQuery}`);
  return data;
}
